import { render, staticRenderFns } from "./PrintContainer.vue?vue&type=template&id=56ba1526&scoped=true&"
import script from "./PrintContainer.vue?vue&type=script&lang=js&"
export * from "./PrintContainer.vue?vue&type=script&lang=js&"
import style0 from "./PrintContainer.vue?vue&type=style&index=0&id=56ba1526&lang=scss&"
import style1 from "./PrintContainer.vue?vue&type=style&index=1&id=56ba1526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba1526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ba1526')) {
      api.createRecord('56ba1526', component.options)
    } else {
      api.reload('56ba1526', component.options)
    }
    module.hot.accept("./PrintContainer.vue?vue&type=template&id=56ba1526&scoped=true&", function () {
      api.rerender('56ba1526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/PrintContainer.vue"
export default component.exports